import create from 'zustand';
import produce from 'immer';
import { nanoid } from 'nanoid';

const STUDENT_MARK_INITIAL = {
	programs: [],
	grades: [],
	courses: [],
	takes: [],
	marks: [],

	edited: false,
	active: 0
};

export const useStudentMarkStore = create(set => ({
	...STUDENT_MARK_INITIAL,

	// Set active grade
	onActive: (id) => set(produce(state => {
		state.active = id;
	})),

	// Handle studentš mark addition
	onAdd: (mark) => set(produce(state => {
		console.log(mark);
		state.marks = [...state.marks, mark];
	})),

	// Handle student's mark update
	onUpdate: (updated) => set(produce(state => {
		const prev = state.marks.find(mark => mark.id === updated.id);
		prev.mark = updated.mark;
	})),

	// Handle student's mark update
	onRemove: (removed) => set(produce(state => {
		state.marks = state.marks.filter(mark => mark.id !== removed.id);
	})),

	// Handle student's mark addition
	onAddMark: (mark) => set(produce(state => {
		state.marks.push({
			key: nanoid(),
			type: mark.type,
			mark: mark.mark,
			gradeId: mark?.grade?.id,
			subjectId: mark?.subject?.id,
			subject: mark.subject,
			grade: mark.grade
		});
		state.edited = true;
	})),

	// Handle student's mark removal
	onRemoveMark: (markKey) => set(produce(state => {
		state.marks = state.marks.filter(mark => mark.key !== markKey);
		state.edited = true;
	})),

	// Initialize student's mark state
	onInit: ({ grades, courses, takes, marks }) => set(produce(state => {
		state.programs = grades?.reduce((result, grade) => {
			return result.some(program => program.id === grade.program.id)
				? result
				: [...result, grade.program];
		}, []);
		state.grades = grades;
		state.courses = courses;
		state.takes = takes;
		state.marks = marks;
		state.edited = false;
		state.active = grades.find(g => g.state === 'active')?.id || grades[0]?.id || 0;
	})),

	// Reset store to initial state
	onReset: () => set({
		...STUDENT_MARK_INITIAL
	})
}));